/**
 * DTOs pour la génération d'activités avec l'IA
 */

import { IsString, IsOptional, IsUUID, IsArray } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class GenerateActivityDto {
  @ApiProperty({
    description: "ID de la leçon pour laquelle générer l'activité",
    example: 'c341dd2d-f900-49b1-b0f0-cbb9b7833e51',
  })
  @IsUUID()
  lessonId!: string;

  @ApiProperty({
    description: "ID du type d'activité à générer",
    example: 'b1c2d3e4-6789-4abc-9def-222222222222',
  })
  @IsUUID()
  activityTypeId!: string;

  @ApiPropertyOptional({
    description: 'Langue de génération',
    example: 'fr',
    default: 'fr',
  })
  @IsOptional()
  @IsString()
  language?: string;

  @ApiPropertyOptional({
    description: 'Liste des IDs des ressources à utiliser',
    example: [
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e51',
      'c341dd2d-f900-49b1-b0f0-cbb9b7833e52',
    ],
  })
  @IsOptional()
  @IsArray()
  @IsUUID(undefined, { each: true })
  resourcesIds?: string[];

  @ApiPropertyOptional({
    description: 'Instructions personnalisées pour la génération',
    example: '',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  customInstructions?: string;
}
